(function () {
  class ImageQuoteSlider {
    constructor(sectionEl) {
      this.section = sectionEl;
      this.viewport = sectionEl.querySelector('[data-iqs-viewport]');
      this.track = sectionEl.querySelector('[data-iqs-track]');
      if (!this.viewport || !this.track) return;

      this.originalSlides = [...this.track.querySelectorAll('[data-iqs-slide]:not([data-iqs-clone])')];
      this.slideCount = this.originalSlides.length;
      if (this.slideCount === 0) return;

      this.slides = this.originalSlides;
      this.loopIndex = 0;
      this.isAnimating = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.prevBtn = sectionEl.querySelector('.iqs-prev');
      this.nextBtn = sectionEl.querySelector('.iqs-next');

      this.onResize = this.debounce(() => this.update(false), 150);
      this.onTransitionEnd = this.handleTransitionEnd.bind(this);

      if (this.slideCount > 1) {
        this.buildLoop();
        this.prevBtn?.addEventListener('click', () => this.navigate(-1));
        this.nextBtn?.addEventListener('click', () => this.navigate(1));
        this.track.addEventListener('transitionend', this.onTransitionEnd);
        window.addEventListener('resize', this.onResize);
        this.bindTouch();
      } else {
        this.originalSlides[0]?.classList.add('is-active');
      }

      this.update(false);

      sectionEl.querySelectorAll('.iqs-slide-image').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => this.update(false), { once: true });
        }
      });
    }

    buildLoop() {
      const firstClone = this.originalSlides[0].cloneNode(true);
      const lastClone = this.originalSlides[this.slideCount - 1].cloneNode(true);

      firstClone.setAttribute('data-iqs-clone', 'true');
      lastClone.setAttribute('data-iqs-clone', 'true');
      firstClone.removeAttribute('data-shopify-editor-block');
      lastClone.removeAttribute('data-shopify-editor-block');

      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, this.originalSlides[0]);

      this.slides = [...this.track.querySelectorAll('[data-iqs-slide]')];
      this.loopIndex = 1;
    }

    navigate(direction) {
      if (this.isAnimating || this.slideCount < 2) return;
      this.isAnimating = true;
      this.loopIndex += direction;
      this.update(true);

      if (this.prefersReducedMotion) {
        this.resetLoopPosition();
        this.isAnimating = false;
      }
    }

    handleTransitionEnd(event) {
      if (event.propertyName !== 'transform') return;
      this.resetLoopPosition();
      this.isAnimating = false;
    }

    resetLoopPosition() {
      if (this.loopIndex === 0) {
        this.loopIndex = this.slideCount;
        this.update(false);
      } else if (this.loopIndex === this.slideCount + 1) {
        this.loopIndex = 1;
        this.update(false);
      }
    }

    bindTouch() {
      let startX = 0;
      let deltaX = 0;

      this.viewport.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
          deltaX = 0;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchmove',
        (event) => {
          deltaX = event.touches[0].clientX - startX;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchend',
        () => {
          if (Math.abs(deltaX) < 40) return;
          this.navigate(deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    update(animate) {
      const index = this.slideCount > 1 ? this.loopIndex : 0;
      const slide = this.slides[index];
      if (!slide) return;

      const viewportWidth = this.viewport.offsetWidth;
      const slideLeft = slide.offsetLeft;
      const slideWidth = slide.offsetWidth;
      const offset = slideLeft + slideWidth / 2 - viewportWidth / 2;

      this.track.style.transition =
        animate && !this.prefersReducedMotion
          ? 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          : 'none';
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      this.slides.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
      });
    }

    debounce(fn, ms) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), ms);
      };
    }
  }

  function initSection(sectionEl) {
    sectionEl._iqsInstance = new ImageQuoteSlider(sectionEl);
  }

  function initAll() {
    document.querySelectorAll('.image-quote-slider[data-iqs-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = document.getElementById('iqs-' + event.detail.sectionId);
    if (section) initSection(section);
  });
})();
